(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.handleBreakpoint = this.onBreakpoint.bind(this)
      this.handleResize = debounce(this.updateHeight.bind(this), RESIZE_DEBOUNCE_TIMER);
      this.enabled = false;
      this.slides = this.querySelectorAll('.announcement-bar');
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      this.mql ??= window.matchMedia('(max-width: 749px)');
      this.mql.addEventListener('change', this.handleBreakpoint);

      if (this.mql.matches) {
        this.enable();
      }

      if(this.slides.length > 1) {
        this.restartInterval();
        this.prevButton = this.querySelector('button[data-prev]');
        this.nextbutton = this.querySelector('button[data-next]');
        this.prevButton.addEventListener('click', this.onPrevButtonClick.bind(this));
        this.nextbutton.addEventListener('click', this.onNextButtonClick.bind(this));
      }
    }

    destroy() {
      this.mql.removeEventListener('change', this.handleBreakpoint);
      this.disable();
      this.stopInterval();
    }

    enable() {
      this.updateHeight();
      window.addEventListener('resize', this.handleResize);
      this.enabled = true;
    }

    disable() {
      this.clearHeight();
      window.removeEventListener('resize', this.handleResize);
      this.enabled = false;
    }

    stopInterval() {
      if(this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    restartInterval() {
      this.stopInterval();
      this.interval = setInterval(() => {
        this.showNextSlide();
      }, Number(this.getAttribute('interval')) * 1000);
    }

    onBreakpoint() {
      if (this.enabled && !this.mql.matches) {
        this.disable();
        return;
      } else if (!this.enabled && this.mql.matches) {
        this.enable();
      }
    }

    onPrevButtonClick() {
      this.restartInterval();
      this.showPrevSlide();
    }

    onNextButtonClick() {
      this.restartInterval();
      this.showNextSlide();
    }

    showPrevSlide() {
      const slides = [...this.slides];
      for(let i=0; i < slides.length; i++) {
        const slide = slides[i];
        if(slide.getAttribute('aria-hidden') === 'false') {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
          const nextSlide = i === 0 ? slides[slides.length  - 1] : slides[i - 1];
          nextSlide.setAttribute('aria-hidden', 'false');
          nextSlide.removeAttribute('inert');
          break;
        }
      }
    }

    showNextSlide() {
      const slides = [...this.slides];
      for(let i=0; i < slides.length; i++) {
        const slide = slides[i];
        if(slide.getAttribute('aria-hidden') === 'false') {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
          const nextSlide = i + 1 === slides.length ? slides[0] : slides[i+1];
          nextSlide.setAttribute('aria-hidden', 'false');
          nextSlide.removeAttribute('inert');
          break;
        }
      }
    }

    clearHeight() {
      document.body.style.removeProperty('--announcement-bars-height');
    }

    updateHeight() {
      if (!this.enabled) return;

      this.clearHeight();

      setTimeout(() => {
        document.body.style.setProperty('--announcement-bars-height', `${this.offsetHeight}px`);
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.type = this.getAttribute('type');
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      if (this.type === 'autohide') {
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
  
        this.createBoundsObserver();
      } else {
        if (this.type === 'sticky') this.createStickyObserver()

        this.reveal();
      }
    }

    disconnectedCallback() {
      this.stickyObserver?.disconnect();

      if (this.type === 'autohide') {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createStickyObserver() {
      this.stickyObserver = new IntersectionObserver((entries, observer) => {
        const isStuck = entries[0].isIntersecting;
        document.body.classList.toggle('has-stuck-header', isStuck);
        document.body.classList.toggle('has-static-header', !isStuck);
      }, {
        rootMargin: `1px 0px ${this.header.offsetHeight - window.innerHeight}px 0px`,
        threshold: [1],
      })

      this.stickyObserver.observe(this.header);
    }

    createBoundsObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
